export default "__VITE_ASSET__WeHRxfL7__"